const resources = {
    freeReturns: 'Retours gratuits',
    exclusions: 'voir les détails et les exceptions.*',
    allPurchases: 'sur tous les achats.*'
};

export default function getResource(label) {
    return resources[label];
}
